import { useEffect } from 'react';

const DEFAULT_FAVICON = `${process.env.PUBLIC_URL}/favicon.ico`;
const CONVERSAS_FAVICON = `${process.env.PUBLIC_URL}/favicon-conversas.ico`;

/** Troca o favicon da aba enquanto isConversas for true; restaura o padrão ao desmontar/desligar. */
export function useProductFavicon(isConversas: boolean): void {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;

    link.href = isConversas ? CONVERSAS_FAVICON : DEFAULT_FAVICON;

    return () => {
      link.href = DEFAULT_FAVICON;
    };
  }, [isConversas]);
}
